export default (vm, message, title = "Success") => {
    vm.$root.$bvToast.toast(message, {
        solid: true,
        title: title,
        variant: "success",
    });
};
